import {
  ALL_SOFTSKILLS_ABILITIES_USERS,
  ALL_SOFTSKILLS_ABILITIES_USERS_SUCCESS,
  ALL_SOFTSKILLS_ABILITIES_USERS_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  users: [],
}

const SoftskillsAbilitiesAllUsers = (state = initialState, action) => {
  switch (action.type) {
    case ALL_SOFTSKILLS_ABILITIES_USERS:
      state = {
        ...state,
        loading: true,
      }
      break
    case ALL_SOFTSKILLS_ABILITIES_USERS_SUCCESS:
      state = {
        ...state,
        users: action.payload.users,
        loading: false,
        done: true,
      }
      break
    case ALL_SOFTSKILLS_ABILITIES_USERS_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsAbilitiesAllUsers
